import { isNumber } from '@sonar-software/sonar-ts-lib';
import React from 'react';
export const VersionNumber = ({ number }) => {
    if (!isNumber(number)) {
        return null;
    }
    const version = `v${number}`;
    return React.createElement("span", { className: 'version' }, version);
};
